module.exports = ".custom-table-padding table tr td {\n  padding: 4px; }\n"